import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';

var ExampleItems = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ExampleItems, _React$Component);

  function ExampleItems() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ExampleItems.prototype;

  _proto.render = function render() {
    var items = this.props.items;
    var customItems = items.slice(0);
    customItems.pop();

    if (customItems.length) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", {
        className: "title"
      }, "EXAMPLES"), customItems.map(function (item, index) {
        var description = item.description,
            code = item.code;
        return /*#__PURE__*/React.createElement("div", {
          key: "tutorial-" + index
        }, description ? /*#__PURE__*/React.createElement("p", {
          className: "description"
        }, description) : null, /*#__PURE__*/React.createElement("pre", {
          className: "codeblock tui-language-javascript"
        }, /*#__PURE__*/React.createElement("code", {
          dangerouslySetInnerHTML: {
            __html: code
          }
        })));
      }));
    }

    return null;
  };

  return ExampleItems;
}(React.Component);

export default ExampleItems;